import React, { Component } from 'react';
import * as d3 from "d3";
import numeral from "numeral";
import tooltip from "./Tooltip.js";
import utils from "./utils.js";
import * as d3annotation from "d3-svg-annotation";
import "./Annotations.css";
const customFormat = (value, format, index) => {
  if(typeof format === 'string'){
    return numeral(value).format(format)
  } else if (typeof format === 'function') {
    return format(value, index)
  }else{
    return value;
  }
}

export default class LineChart extends Component {
  constructor(props) {
    super(props)

    
  }
  componentDidMount() {
    this.renderArea()
  }
  componentWillReceiveProps(nextProps){
    if((!typeof(nextProps.lineChartChildComponen)=='object') || (nextProps.lineChartChildComponen==null)){
      this.renderArea(nextProps)
    }
    
  }

  componentDidUpdate() {
    // this.renderArea()
  }

  renderArea(nextProps){
    var { mainDivId,id,yAxisScale,xAxisScale, margins, data, svgDimensions,xField,yField,strokeColor,lineStyle,isGroupBar,groupIndex,curveStyle,type,xAxisData,
          dataLabels,marker,tooltip,name,showLineChartTooltip,hideLineChartTooltip,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition,gridLineYAxis, annotationsData } =nextProps || this.props;
    curveStyle=(curveStyle!=undefined || curveStyle!=null) ? curveStyle : 'curveLinear';
    const { height } = svgDimensions;
    var chartHeight=this.props.svgDimensions.height-margins.top-margins.bottom;
    var defaultDataLabelFormat=function(d){
      return d;
    };//"0,0.[00]"
    tooltipStyle.format= tooltipStyle.format!=undefined ? tooltipStyle.format : ((yAxisScale.labels && yAxisScale.labels.format) || defaultDataLabelFormat);
    tooltipStyle.prefix= tooltipStyle.prefix!=undefined ? tooltipStyle.prefix : ((yAxisScale.labels && yAxisScale.labels.prefix) || '');
    tooltipStyle.postfix= tooltipStyle.postfix!=undefined ? tooltipStyle.postfix : ((yAxisScale.labels && yAxisScale.labels.postfix) || '');
    // var area = d3.area()
    // .curve(d3[curveStyle])
    // .x(function(d) { 
    //     return xAxisScale.scale(d[xField])+(xAxisScale.scale.bandwidth()/2); 
    // })
    // .y0(svgDimensions.height- margins.bottom)
    // .y1(function(d) { 
    //     return yAxisScale.scale(d[yField]);
    //  });

    var curveStyle = 'curveLinear';
    if(type=='spline'){
        curveStyle = 'curveMonotoneX';
    }
    var preparedData=[];
    xAxisData.forEach(function(d,index){
      if(data[index]!=null){
        preparedData.push($.extend({data:data[index]}, {
          xAxisValue:(d!=null && typeof(d)=='object') ? d.data : d,
          yAxisValue:typeof data[index] == 'object' ? data[index]["data"] : data[index],
          fillColor:typeof data[index] == 'object' && data[index]["fillColor"]!=null ? data[index]["fillColor"] : null
        }));
      }
    });
    var fillColor=(lineStyle.fillColor ? lineStyle.fillColor : strokeColor);
    var strokeOpacity=(lineStyle.strokeOpacity ? lineStyle.strokeOpacity : 1);
    var strokeDashArray=(lineStyle.strokeDashArray ? lineStyle.strokeDashArray : 0);
    var strokeWidth=(lineStyle.strokeWidth ? lineStyle.strokeWidth : 2);
    var valueline = d3.line()
    .curve(d3[curveStyle])
    .x(function(d) { return xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2);  })
    .y(function(d) { return yAxisScale.scale(d.yAxisValue);  });
    d3.selectAll('#LineChartContainer_'+this.props.id).selectAll('*').remove();
    d3.selectAll('#LineChartContainer_'+this.props.id)
    .append("path")
    .data([preparedData])
    .style("fill-opacity",0)
    .style("stroke-dasharray",strokeDashArray)
    .style("stroke-opacity",strokeOpacity)
    .attr("stroke",fillColor)
    .attr("stroke-width",strokeWidth)
    .attr("class", "Line")
    .attr("d", valueline);

    if(annotationsData && annotationsData.length > 0) {
      const makeAnnotations = d3annotation.annotation()
        .type(d3annotation.annotationBadge)
        .accessors({ 
          x: function(d){ return xAxisScale.scale(d.x)},
          y: function(d){ return yAxisScale.scale(d.y)}
        })
        .annotations(annotationsData)

      d3.select('#LineChartContainer_'+this.props.id)
        .append("g")
        .attr("class", "annotation-group")
        .call(makeAnnotations);
    }

    var that=this;
     //CBT:this is for data label
    if(dataLabels!=undefined && dataLabels !=null && dataLabels.enabled==true){
      var format=dataLabels.format || (yAxisScale.labels && yAxisScale.labels.format) || defaultDataLabelFormat;
      var prefix=dataLabels.prefix || (yAxisScale.labels && yAxisScale.labels.prefix) || "";
      var postfix=dataLabels.postfix || (yAxisScale.labels && yAxisScale.labels.postfix) || "";
      d3.selectAll('#LineChartLabelTextContainer_'+that.props.id).selectAll('*').remove();
      data.forEach(function(datum,index) {
        datum=(datum!=null && typeof(datum)=='object') ? datum["data"]:datum;
        var xAxisLabels= (xAxisData[index]!=null && typeof(xAxisData[index])=='object') ? xAxisData[index]["data"]  :xAxisData[index];
        var style=$.extend({'textAnchor':'middle'},false,(dataLabels && dataLabels.style ? dataLabels.style :{}));
          d3.selectAll('#LineChartLabelTextContainer_'+that.props.id)
          .append('text')
          .attr("x",xAxisScale.scale(xAxisLabels)+(xAxisScale.scale.bandwidth()/2))
          .attr('y',yAxisScale.scale(datum)-5)
          .style("fill",'#000')
          .attr('style',utils.convertReactStyleToHtml(style))
          .text(prefix+""+customFormat(datum,format, index)+""+postfix );
        })
    }
    //CBT:This is for marker
    var globalTooltipShowLine=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.showLine || false ) : false;
    var globalTooltipCategory=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.category || '' ) : '';
    var symbol=marker.symbol || 'circle';
    var fillColorMarker=(marker.fillColor!=undefined && marker.fillColor !=null) ? marker.fillColor :'transparent';
    var strokeColorMarker=(marker.strokeColor!=undefined && marker.strokeColor !=null) ? marker.strokeColor :'transparent';
    var strokeWidthMarker=(marker.strokeWidth!=undefined && marker.strokeWidth !=null) ? marker.strokeWidth :"0px";
    var radius=marker.radius || 5;
    var hilightColorMarker=(marker.hilightColor!=undefined && marker.hilightColor !=null) ? marker.hilightColor : fillColorMarker;
    var hilightStrokeColorMarker=(marker.hilightStrokeColor!=undefined && marker.hilightStrokeColor !=null) ? marker.hilightStrokeColor : strokeColorMarker;
    var hilightStrokeWidthMarker=(marker.hilightStrokeWidth!=undefined && marker.hilightStrokeWidth !=null) ? marker.hilightStrokeWidth : strokeWidthMarker;
    var hilightRadius=marker.hilightRadius || radius;
    if(symbol=='circle'){
      d3.selectAll("#LineChartMarkerContainer_"+that.props.id).selectAll('*').remove();
      var markersCircle=d3.selectAll("#LineChartMarkerContainer_"+that.props.id)
      .selectAll("circle")
      .data(preparedData).enter()
      .append('circle')
      .attr("data",function(d,index){
              var globalData={xAxisTooltipsLabel:d.xAxisValue,
                dataIndex:index,
                x:xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2),
                y:yAxisScale.scale(d.yAxisValue),
                r:radius
              }
              return JSON.stringify(globalData);
      })
      .attr('cx',function(d){
        return xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2)
      })
      .attr('globalX',function(d){
        return (xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2)).toString().split(".").join("_");
      })
      .attr('cy',function(d){
        return yAxisScale.scale(d.yAxisValue)
      })
      .attr("r",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightRadius;
        }else{
        return radius;
        }
      })
      .style("stroke-width",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightStrokeWidthMarker;
        }else{
          return strokeWidthMarker;
        }
      })
      .style("stroke",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightStrokeColorMarker;
        }else{
          return strokeColorMarker;
        }
      })
      .style("fill",function(d){
        if(d.fillColor!=null)
            return d.fillColor;
        else
          return fillColorMarker;
      })
      .attr("originalfill",function(d){
        if(d.fillColor!=null)
            return d.fillColor;
        else
          return fillColorMarker;
      })
      .on("click",(d)=> {
        if(this.props.onCircleClick!=null && typeof(this.props.onCircleClick)=='function'){
          this.props.onCircleClick(d);
        }
      });
      
      //CBT:GridLine Start
      if(gridLineYAxis!=null && typeof(gridLineYAxis)=='object'){
        var hilightCirlce=null;
        var hilightAbove={};
        var hilightBellow={};
        var hilightMiddle={};
        var points=gridLineYAxis.points || [{y1:yAxisScale.scale.invert(chartHeight * 0.25),y2:yAxisScale.scale.invert(chartHeight * 0.25)},{y1:yAxisScale.scale.invert(chartHeight * 0.75),y2:yAxisScale.scale.invert(chartHeight * 0.75)}];
        // if(points.length==1){
        //   points.push({
        //     y1:0,
        //     y2:0 
        //   })
        // }
        points=points.sort(function(a,b){
          return a.y1-b.y1;
        });
        if(gridLineYAxis.hasOwnProperty("hilightCirlce") && typeof(gridLineYAxis.hilightCirlce)=='object' && gridLineYAxis.hilightCirlce!=null){
          if(gridLineYAxis.hilightCirlce.hasOwnProperty("above")){
            hilightAbove=gridLineYAxis.hilightCirlce.above;
          } 
          if(gridLineYAxis.hilightCirlce.hasOwnProperty("bellow")){
            hilightBellow=gridLineYAxis.hilightCirlce.bellow;
          }
          if(gridLineYAxis.hilightCirlce.hasOwnProperty("middle")){
            hilightMiddle=gridLineYAxis.hilightCirlce.middle;
          }
          var minRange=points.length==1 ? yAxisScale.scale(points[0]["y1"]) : (yAxisScale.scale(points[0]["y1"]) < yAxisScale.scale(points[1]["y1"]) ? yAxisScale.scale(points[0]["y1"]) :yAxisScale.scale(points[1]["y1"]));
          var maxRange=points.length==1 ? yAxisScale.scale(points[0]["y1"]) : (yAxisScale.scale(points[0]["y1"]) > yAxisScale.scale(points[1]["y1"]) ? yAxisScale.scale(points[0]["y1"]) :yAxisScale.scale(points[1]["y1"]));
          d3.selectAll(".LineChartMarkerContainer_"+mainDivId).selectAll("circle")
          .style("fill",function(d){
            var currentCy=parseFloat(this.getAttribute("cy"));
            var currentFillColor=d3.select(this).style("fill");
            if(currentCy<=minRange && hilightAbove.isHilight==true){  
              return (hilightAbove.fillColor || '#d0021b')
            }else if(currentCy>=maxRange && hilightBellow.isHilight==true){  
              return (hilightBellow.fillColor || '#d0021b')
            }else if(currentCy>=minRange && currentCy<=maxRange && hilightMiddle.isHilight==true){  
              return (hilightBellow.fillColor || '#d0021b')
            }else{
              return currentFillColor;
            }
          });

           
        }
      }
      //CBT:GridLine End
      markersCircle.transition().duration(300).style("fill",function(d){
        var currentFillColor=d3.select(this).style("fill");
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightColorMarker;
        }else{
          return currentFillColor;
        }
      });
      // .style("stroke-opacity",0);
     
      //CBT:THis is for tooltips 
      if(tooltip==true){
        markersCircle.on("mouseenter",(e)=>{
          // d3.select(d3.event.target).transition().style("stroke-opacity",0.5);
          d3.select(d3.event.target).transition().style("stroke",hilightStrokeColorMarker);
          d3.select(d3.event.target).transition().style("stroke-width",hilightStrokeWidthMarker);
          d3.select(d3.event.target).transition().style("fill",hilightColorMarker);
          d3.select(d3.event.target).transition().attr("r",hilightRadius);
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.xAxisValue]:e.yAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition,(e.data != null && typeof (e.data) == 'object' && e.data.typeOfTooltip != null) ? (e.data.typeOfTooltip):null,(e.data != null && typeof (e.data) == 'object' && e.data.tooltipData != null) ? (e.data.tooltipData):null);
        })
        if(tooltipPosition.toLowerCase()=='cursor'){
            markersCircle.on("mousemove",(e,index)=>{
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.xAxisValue]:e.yAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition,(e.data != null && typeof (e.data) == 'object' && e.data.typeOfTooltip != null) ? (e.data.typeOfTooltip):null,(e.data != null && typeof (e.data) == 'object' && e.data.tooltipData != null) ? (e.data.tooltipData):null);
          });
        }
        markersCircle.on("mouseout",function(d,mouseEvent){
          // d3.select(d3.event.target).transition().style("stroke-opacity",0);
          d3.select(d3.event.target).transition().style("stroke",fillColorMarker);
          d3.select(d3.event.target).transition().style("stroke-width",strokeWidthMarker);
          d3.select(d3.event.target).transition().style("fill",fillColorMarker);
          d3.select(d3.event.target).transition().attr("r",radius);
          hideDetail();
        });
      }else if(tooltip!=false && typeof(tooltip)=='object'){
        markersCircle.on("mouseenter",null);
        markersCircle.on("mouseenter",(e)=>{
           var cx=xAxisScale.scale(e.xAxisValue)+(xAxisScale.scale.bandwidth()/2);
           var cy=yAxisScale.scale(e.yAxisValue)
           showLineChartTooltip(tooltip,{x:cx,y:cy,radius:radius,id:id,tooltipStyle:tooltipStyle}); 
        });
        markersCircle.on("mouseout",null);
        markersCircle.on("mouseout",function(d){
          hideLineChartTooltip();
        });
        
      }
    }
  }
  componentWillUnmount(){
    hideDetail();    
  }
  // convertReactStyleToHtml=(rectStyleObj)=>{
  //   var htmlStyleObj='';
  //   if(rectStyleObj.hasOwnProperty("textAnchor")){
  //     htmlStyleObj=htmlStyleObj+'text-anchor:'+rectStyleObj.textAnchor+";";
  //   }
  //   if(rectStyleObj.hasOwnProperty("color")){
  //     htmlStyleObj=htmlStyleObj+'color:'+rectStyleObj.color+";";
  //   }
  //   if(rectStyleObj.hasOwnProperty("fill")){
  //     htmlStyleObj=htmlStyleObj+'fill:'+rectStyleObj.fill+";";
  //   }
  //   if(rectStyleObj.hasOwnProperty("fontSize")){
  //     htmlStyleObj=htmlStyleObj+'font-size:'+rectStyleObj.fontSize+";";
  //   }
  //   if(rectStyleObj.hasOwnProperty("fontStyle")){
  //     htmlStyleObj=htmlStyleObj+'font-style:'+rectStyleObj.fontStyle+";";
  //   }
  //   if(rectStyleObj.hasOwnProperty("fontFamily")){
  //     htmlStyleObj=htmlStyleObj+'font-family:'+rectStyleObj.fontFamily+";";
  //   }
  //   return htmlStyleObj;
  // }
  render() {
    const { yAxisScale,xAxisScale, margins, data, svgDimensions,xField,yField,fillColor,isGroupBar,groupIndex } = this.props
    const { height } = svgDimensions;
    var that=this;

    return (
       <g> <g
        className={'LineChartContainer_'+this.props.id}
        id={"LineChartContainer_"+this.props.id}
        transform={"translate(0,0)"}
        ref={(el) => { this.areaContainer = el; }}
      />
      <g
        id={"LineChartLabelTextContainer_"+this.props.id}
          transform={"translate(0,0)"}>

        </g>
        <g
        id={"LineChartMarkerContainer_"+this.props.id}
        className={"LineChartMarkerContainer_"+this.props.mainDivId}
          transform={"translate(0,0)"}>

        </g>
        { React.Children.count(this.props.children) ? 
        <g className="lineChartChildComponent">
          { React.Children.map(this.props.children,function(child,index){
              return (<g key={index}  className="lineChartChildComponent">{child}</g>);
            })
          }
        </g> 
        : null
        }  
        </g>
    )
  }
}

export function showDetail(props, data, mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition,typeOfTooltip,tooltipData) {
  var defaultValueFormat=function(d){
      return d;
    };
  var labelFontSize =tooltipStyle.labelFontSize ||  "12px";
  var labelFontColor =tooltipStyle.labelFontColor ||  "black";
  var labelFontFamily = tooltipStyle.labelFontFamily ||  "";
  var valueFontSize =tooltipStyle.valueFontSize ||  "12px";
  var valueFontColor =tooltipStyle.valueFontColor ||  "black";
  var valueFontFamily =tooltipStyle.valueFontFamily ||  "";
  if(props.tooltip===true){
    var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
    var format=tooltipStyle.format || defaultValueFormat;
    var prefix=tooltipStyle.prefix || '';
    var postfix=tooltipStyle.postfix || '';
    data.map(function(d) {
       if(typeOfTooltip=="html"){
        d["content"]=tooltipData;
      }else{
      let  content = `<tr>
          <td colspan="2" class="value"  style="text-align: center;letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
        d["name"]
      }</td></tr>`;
      delete d.name;
      var tooltipsContents = Object.keys(d);
      tooltipsContents.map(function(data, index) {
        content =
          content +
          `<tr><td class="key" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${labelFontSize};font-family:${labelFontFamily};color:${labelFontColor}">${data} </td>
              <td class="value" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
                prefix+""+customFormat( d[data],format,index)+""+postfix
          }</td></tr>`;
      });
  
      d["content"] = content;
      }
      
      d["x"] = (tooltipPosition=="cursor")? d3.event.x : globalData.x + $("#" + props.id).offset().left;//d3.event.x;
      d["y"] =(tooltipPosition=="cursor")? d3.event.y : globalData.y+ $("#" + props.id).offset().top;// d3.event.y;
      d["mainDivId"] = props.id;
      d["marginLeft"] = props.margins.left;
      d["marginTop"] = props.margins.top;
    });
    tooltip.showTooltip(data, d3.event, "tooltip_map",(tooltipPosition=="cursor") ?  true :false,globalTooltip);//,isMouseMove,isGlobalTooltip
  }else{
  }  
  
}

export function hideDetail(d) {
  tooltip.hideTooltip();
}
